/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { HeroSection, BackArrowComp, RightContainer } from '../components';
import { vappContainer } from '@/application';
import { Col, Row, Card, Button, Image } from 'react-bootstrap';
import { useSMAboutMe } from '@pages/AboutMePage/machines';
import { AboutMePageService } from '@pages/AboutMePage/services';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { SearchFilter } from '../../../widgets/filter-widget-react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const getSrv = () => {
  return vappContainer.get<AboutMePageService>(AboutMePageService.displayName);
};

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary me-3',
      cancelButton: 'btn btn-secondary',
    },
    buttonsStyling: false,
  })
);

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const srv = getSrv();
  const theme = useTheme();

  const { aboutMePageMachine, aboutMePageSend, aboutMePageState } =
    useSMAboutMe({});
  console.log('render page', aboutMePageState?.event?.data?.value);
  const onRefresh = () => {
    aboutMePageSend('TRIGGER_REFRESH', {});
  };

  const _renderNotification = () => {
    return null;
  };
  const _renderAboutMe = () => {
    if (aboutMePageState?.matches('RENDER_ABOUT_ME')) {
      return (
        <>
          <Card>
            <Card.Body>
              <HeroSection
                {...(aboutMePageState?.event?.data?.value?.feature || {})}
              />
              <RightContainer
                {...(srv?.agent?.getStaticPageAboutMeSync() || {})}
              />
            </Card.Body>
          </Card>
        </>
      );
    }
    if (aboutMePageState?.matches('GET_ABOUT_ME')) {
      return (
        <StateOSD {...(aboutMePageState?.loading?.loadingProfile || {})} />
      );
    }
    return null;
  };
  const _renderErrorModals = () => {
    if (aboutMePageState?.matches('RENDER_ABOUT_ME_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorContentSync()?.error?.getPageContent || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };
  const _renderHeader = () => {
    return <BackArrowComp />;
  };

  const _renderPage = () => {
    return (
      <>
        {_renderHeader()}
        {_renderAboutMe()}
        {_renderErrorModals()}
        {_renderNotification()}
      </>
    );
  };
  return <>{_renderPage()}</>;
};
